import React from 'react';

const UserProfile = React.lazy(() => import('./UserProfile'));
export const profilePageConfig = [
  {
    path: '/my-profile',
    element: <UserProfile />,
  },
];
